<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('模块名称')" prop="workName">
                <a-input v-model="model.workName" :placeholder="$t('请输入模块名称')"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('流程选择')" prop="deploymentId">
                <a-select v-model="model.deploymentId" :placeholder="$t('请选择流程')" @change="flowChange">
                  <a-select-option v-for="item in list" :value="item.deploymentId">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('模块描述')">
                <a-textarea v-model="model.workRemark" :placeholder="$t('请输入模块描述')" :rows="4" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="12">
              <a-form-model-item label="模块图标" prop="workPicture">
                <j-image-upload class="avatar-uploader" text="上传" :isMultiple="false" v-model="workPictureList" v-if="!disableSubmit"></j-image-upload>
                <div v-else style="width: 120px;height: 120px;border: 1px dashed #d9d9d9;padding: 8px;border-radius: 4px;">
                  <img :src="workPicture" alt="" style="width: 100%;height: 100%;" />
                </div>
              </a-form-model-item>
            </a-col> -->
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JImageUpload from '@/components/jeecg/JImageUpload'
import { list } from 'postcss'
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      JImageUpload,
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-oa/workBench/oaWorkbench/add",
          edit: "/jeecg-oa/workBench/oaWorkbench/edit",
          queryById: "/jeecg-oa/workBench/oaWorkbench/queryById",
          flowList: "/jeecg-oa/flowable/definition/list",
        },
        list:[],
        workPictureList:[],
        workPicture: ''
      }
    },
    computed: {
      validatorRules() {
        return {
          workDate: [{
            required: true,
            message: this.$t('请选择工作日期'),
            trigger: 'change'
          }],
          employee: [{
            required: true,
            message: this.$t('请选择工作人员'),
            trigger: 'change'
          }],
          departName: [{
            required: true,
            message: this.$t('请选择所属部门'),
            trigger: 'change'
          }],
        }
      },
    },
    methods: {
      flowChange(e){
        var row = this.list.find(item=>item.deploymentId == e);
        this.$set(this.model,'category',row.category);
        this.$set(this.model,'flowName',row.name);
        this.$set(this.model,'procDefId',row.id);
        this.$set(this.model,'procKey',row.key);
      },
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if(this.model.workPicture){
          // this.$set(this.model,'workPicture',window._CONFIG['staticDomainURL'] + "/" + this.model.workPicture);
          this.workPictureList = [this.model.workPicture];
        }
        if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
          if(this.model.workPicture){
            this.workPicture = window._CONFIG['staticDomainURL'] + "/" + this.model.workPicture;
          }
        }else{
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }
        getAction(this.url.flowList,{pageSize:999}).then(res=>{
          if(res.success){
            this.list = res.result.records;
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      }
    }
  }
</script>